<template>
  <div class="overview" :style="{ 'background-image': `url(${currentImage})` }">
    <div class="neirong">

      <div class="top">
        <div class="title">
          <h1
            class="english"
            style="color:white;"
            :class="{'animate__animated': isVisible, 'animate__bounceInLeft': isVisible, 'fixed-text': isFixed}"
            v-show="isVisible"
              @animationend="handleAnimationEnd"
          >
            INDUSTRIAL <br>PROFILEL
          </h1>
          <h1 style="color:#76BD25;"
          :class="{ 'animate__animated': isVisible, 'animate__fadeIn': isVisible }"
          v-show="isVisible"
          @animationend="handleAnimationEnd">
            ———
          </h1>
          <h1 style="color:black;"
          :class="{'animate__animated': isVisible, 'animate__bounceInLeft': isVisible, 'fixed-text': isFixed}"
            v-show="isVisible"
              @animationend="handleAnimationEnd">
            产业概况
          </h1>
        </div>
        
        <div class="view_cut">
          <ul>
            <li
              :class="{'active': isxian === 'wlfg'}"
              @click="cutClick('wlfg')"
            >
              <a class="bai">网络覆盖</a>
            </li>
            <li
              :class="{'active': isxian === 'ywjg'}"
              @click="cutClick('ywjg')"
            >
              <a class="a">业务结构</a>
            </li>
            <li
              :class="{'active': isxian === 'fzlc'}"
              @click="cutClick('fzlc')"
            >
              <a class="a">发展历程</a>
            </li>
          </ul>
        </div>
      </div>
    <div
      class="wlfg"
      v-if="current ==='wlfg'"
    >
      <div class="white_kuang" :class="{'animate__animated': isbaikuang, 'animate__bounceInUp': isbaikuang}"
      v-show="isbaikuang"
          @animationend="handleAnimationEnd"
      >
        <div class="text">
          <h1>网络覆盖</h1>
          <p>浙江全省11个地级市;32个市辖区、22个县级市、35个县、1个自治县，覆盖药店和诊所、民营医院5000多家。</p>
        </div>
      </div>
    </div>
    <div
      class="ywjg"
      v-else-if="current ==='ywjg'"
    >
      <div class="label">
        <div
          class="label1 animate__animated animate__flipInX"
          style="margin-right: 30px;margin-left: 33px;"
        >
          <span>药品代理销售</span>
        </div>
        <div
          class="label1 animate__animated animate__flipInX animate__delay-1s"
          style="margin-right: 30px;margin-left: 187px;"
        >
          <span>自营连锁</span>
        </div>
        <div
          class="label1 animate__animated animate__flipInX animate__delay-2s"
          style="margin-right: 30px;margin-left: 187px;"
        >
          <span>专业物流配送</span>
        </div>
        <div
          class="label1 animate__animated animate__flipInX animate__delay-3s"
          style="margin-right: 30px;margin-left: 33px;margin-top: 50px;"
        >
          <span>连锁药店委托配送</span>
        </div>
        <div
          class="label1 animate__animated animate__flipInX animate__delay-4s"
          style="margin-right: 30px;margin-left: 187px;margin-top: 50px;"
        >
          <span>电子商务 (筹备中)</span>
        </div>
      </div>
    </div>
    <div
      class="fzlc"
      v-else="current ==='fzlc'"
    >
      <div class="date">
        <div class="left">
          <ul>
            <li>2016年8月<a>&nbsp&nbsp&nbsp公司注册成立</a></li>
            <li>2017年8月<a>&nbsp&nbsp&nbsp通过省药监局验收并取得药品经营许可和GSP证书</a></li>
            <li>2019年8月<a>&nbsp&nbsp&nbsp收购《温州鑫三德医药连锁》</a></li>
            <li>2019年10月<a>《温州乐家医药连锁》签署委托配送协议</a></li>
          </ul>
        </div>
        <div class="right">
          <ul>
            <li>2020年2月<a>开始筹备医疗器械生产并取得二类医疗<p>器械、生产许可</p></a></li>
            <li>2020年4月<a>与《浙江国济医药连锁》签署委托配送<p>协议</p></a></li>
            <li>2021年<a>&nbsp&nbsp&nbsp&nbsp正式启动“医药共享仓”平台建设</a></li>
            <li>2022年<a>&nbsp&nbsp&nbsp&nbsp旗下成立浙江温周药铺有限公司</a></li>
            <li>2023年<a>&nbsp&nbsp&nbsp&nbsp成立多家连锁药铺分部与浙南地区</a></li>
          </ul>
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      current: 'wlfg',
      isxian: 'wlfg',
      images: {
        wlfg: require('../../assets/images/new/wz1.png'),
        ywjg: require('../../assets/images/new/gai2.jpg'),
        fzlc: require('../../assets/images/new/gai3.jpg'),
      },
      isVisible: false,
      scrollY: 0,
      isFixed: false,
      isbaikuang:false
    }
  },
  methods: {
    handleScroll() {
      this.scrollY = window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      console.log(this.scrollY);
      
      if (this.scrollY >= 1000) {
        this.isVisible = true;
      }
      if (this.scrollY >= 1400) {
        this.isbaikuang = true;
      }
    },
    handleAnimationEnd() {
      this.isFixed = true;
    },
    cutClick(title) {
      this.current = title;
      if (title == 'ywjg') {
        document.querySelector('.english').style.color = '#76BD25'
        this.isxian = title
      } else {
        document.querySelector('.english').style.color = 'white'
        this.isxian = title
      }
    }
  },
  computed: {
    currentImage() {
      return this.images[this.current];
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  }
    }
</script>

<style scoped>
  .overview{
    align-items: center;
    justify-content: center;
    height: 880px;
    max-width: 100vw;
    width: 100%;
    background-position: center;
    background-size: cover;
  }
  .neirong{
    padding-top: 100px;
    padding-left: 50px;
    max-width: 1200px;
    height: auto;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
  }
  .top{
    display: flex;
    width: 100%;
    justify-content: space-between;
    
  }
  /* 小标题 */
  .title{
    max-width: 500px;
  }
  .title h1{
    font-weight:bold;
    font-size: 2.5rem;
  }
  .view_cut{
    max-width: 100px;
  }
  .view_cut>ul>li{
    font-size: 1.5rem;
    font-weight:500;
    line-height: 90px;
  } 
  .view_cut ul{
    cursor: pointer;
    list-style-type: none;
    padding: 0;
    margin: 0;
  }
  .view_cut ul li a {
    text-decoration: none;
    position: relative;
    padding-bottom: 5px;
  }
  /* 下划线  */
  .active .bai::after{
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: white;
    transition: left 0.3s;
    border-radius:25px;
  }
  .active .a::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #5bb62d;
    transition: left 0.3s;
    border-radius:25px;
  }

  /* 内容 */
  /* 网络覆盖 */
  .wlfg{
    padding-top: 130px;
    max-width: 1200px;
    display: flex;
    justify-content: flex-end;
  }
  .white_kuang{
    width: 903px;
    height: 223px;
    background-color: rgba(255, 255, 255, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .text{
    width: 790px;
    height: 140px;
    /* background-color: #5bb62d; */
  }
  .text h1{
    font-size: 2rem;
    font-weight: bold;
    margin-bottom: 6px;
  }
  .text>p{
    font-size: 1.2rem;
    line-height: 45px;
    /* font-weight:700; */
    font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  }
  /* 业务结构 */
  .ywjg{
    max-width: 1200px;
    padding-top: 50px;
  }
  .label{
    flex-wrap: wrap;
    display: flex;
    height: 300px;
    align-items: center;
    /* background-color: rgba(255, 255, 255, 0.7); */
  }
  .label1{
    width: 230px;
    height: 80px;
    background-color: #77BD26;
    display:inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 25px;
    box-shadow:5px 5px 10px 0px rgba(0, 0, 0, 0.5);
  }
  .label1>span{
    color: white;
    font-size: 25px;
    font-weight: bold;
  }
  /* 发展历程 */
  .fzlc{
    max-width: 1200px;
    padding-top: 50px;
    height: 350px;
    font-size: 22px;
  }
  .date{
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    /* background-color: rgba(255, 255, 255, 0.7); */
  }
  .date ul li{
    font-size: 1.3rem;
    line-height: 45px;
    list-style-type:disc;
  }
  .date ul li>a{
    color:white;
    margin-left: 10px;
    letter-spacing:1px;
  }
  .date ul li>a>p{
    text-indent: 5.3em;
  }
  @media (max-width: 1400px){
    .white_kuang{
      width: 603px;
      height: 180px;
    }
    .text{
      width: 490px;
      height: 130px;
      /* background-color: #5bb62d; */
    }
    .text h1{
      font-size: 1.8rem;
    }
    .text>p{
      font-size: 1rem;
    }
  }
  @media (max-width: 1200px){
    .title h1{
      font-size: 2.0rem;
    }
    .label{
      flex-direction: column;
      
  }
    .date ul li{
      font-size: 1rem;
    }
  }
    @media (max-width: 800px){
      .date ul li{
      font-size: 0.7rem;
      line-height: 30px;
    }
    }
    @media (max-width: 700px){
      .date ul li{
      font-size: 0.5rem;
      line-height: 25px;
    }
    .title h1{
      font-size: 1.5rem;
    }
    .view_cut>ul>li{
      font-size: 1.0rem;
      padding-right: 30px;
    } 
    .white_kuang{
      width: 403px;
      height: 120px;
    }
    .text{
      width: 290px;
      height: 80px;
      /* background-color: #5bb62d; */
    }
    .text h1{
      font-size: 1rem;
    }
    .text>p{
      font-size: 0.7rem;
      line-height: 30px;
    }
    }
    @media (max-width: 500px){
      .date ul li{
      font-size: 0.3rem;
      line-height: 15px;
    }
    }
</style>